import { formatISO } from "date-fns";
import { ReportFilters } from "@common/types/filters/reports";
import { exportCashFlowReport } from "@api/cashFlow.api";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";

export function useCashFlowReportDownload(filters: ReportFilters) {
    return useFileDownload(async () => {
        const response = await exportCashFlowReport({ filters });

        const datesInterval = [
            filters.start
                ? formatISO(filters.start, { representation: "date" })
                : "",
            filters.end
                ? formatISO(filters.end, { representation: "date" })
                : "",
        ]
            .filter(Boolean)
            .join("-");

        const dateSuffix = datesInterval ? ` ${datesInterval}` : "";
        const fileName = `Cash Flow${dateSuffix}.xlsx`;

        saveBlobResponse(response, fileName);
    });
}
